import React, { useEffect, useState } from "react";
import { getNotifications } from "../../Api/firebaseAPis";
import Header from "../../Components/Header";
import { FixedSizeList } from "react-window";
import ListItem from "@mui/material/ListItem";
import Post from "../Components/Post";
import NotificationPost from "../Components/NotificationPost";
import { getFollowersAndFollowing } from "../../Api/Flask/userapis";
import { Empty } from 'antd';
import GifLoader from "../Components/GifLoader";
function NotificationPageRes() {
  const [notifications, setNotifications] = useState([]);
  const [followlist,setFollowList]=useState([]);
  const [length, setLength] = useState(5);
  const [visibleItemCount, setVisibleItemCount] = useState(5);
  const [txt, settxt] = useState("Load More+");
  const [eventNotifications, setEventNotifications] = useState([]);
  const [loader,setLoader]=useState(false)
  function renderRow(props) {
    const { index, style,data } = props;


    return (
        <>
         <ListItem style={style}>
           
        {
            followlist.includes(notifications[data[index]].sender)?<NotificationPost
            data={props.data ? notifications[props.data[index]] : ""}
            id={props.data ? props.data[index] : ""} selectedFlag={true}
          />:<NotificationPost
          data={props.data ? notifications[props.data[index]] : ""}
          id={props.data ? props.data[index] : ""} selectedFlag={false}
        />
         }
        
      </ListItem>
     
        </>
     
    );
  }


  function renderRow2(props) {
    const { index, style,data } = props;


    return (
        <>
         <ListItem className="my-4" style={style}>

         <NotificationPost
          data={props.data ?data[index] : ""}
          id={props.data ? data.id : ""} type="view"
        />
      
        
      </ListItem>
        
        </>
     
    );
  }

  const getAllflowersandflowing=async()=>{
    setLoader(true)
    let uid=localStorage.getItem('uid');
    try {
        const res=await getFollowersAndFollowing({uid});
        setFollowList(res['following_list']);
    } catch (error) {
        console.log("error in getting following list")
    }
    setLoader(false)
  } 

  useEffect(() => {
    getAsyncData();
  }, [visibleItemCount]);
useEffect(()=>{
    getAllflowersandflowing();
},[])
  const getAsyncData = async () => {
    setLoader(true)
 
    const uid = localStorage.getItem("uid");
 
    const all_notifications = await getNotifications(uid);
    

    var notificationData = Object.keys(all_notifications).map(function (key) {
      all_notifications[key]["id"] = key;
      return all_notifications[key];
    });
    const keys = ["body"];
    const filtered = notificationData.filter(
      (
        (s) => (o) =>
          ((k) => !s.has(k) && s.add(k))(keys.map((k) => o[k]).join("|"))
      )(new Set())
    );
    setLength(filtered.length);
    let newdata = filtered.slice(0, visibleItemCount);
    setNotifications(newdata);
   let InvitationData= Object.keys(all_notifications).filter((ele)=>{
        return all_notifications[ele].title="Invitation"
    }).map((ele)=>{
        return (all_notifications[ele])
    })
   setEventNotifications(InvitationData);
   setLoader(false)
  };
  
  const handleData = () => {
    if (visibleItemCount === 5) {
        setVisibleItemCount(length);
        settxt("Show Less");
        
    
    } else {
        setVisibleItemCount(5);
        settxt("Load More +");
       
      
    }
  };
  return (
    <>
      {loader?<GifLoader/>:<>
      <div className="col">
        <div
          className="row"
          style={{
            justifyContent: "center",
            backgroundColor: "#141414",
            padding: 20,
          }}
        >
          <div>
            <h3 className="font-medium">Notifications</h3>
          </div>
        </div>
        {
            notifications.length>0 ?
            <div className="relative overflow-hidden">
            <FixedSizeList         
              height={550}
              width={"100%"}
              itemSize={100}
              itemCount={notifications.length}
              overscanCount={5}
              itemData={Object.keys(notifications)}
            >
              {renderRow}
            </FixedSizeList>
            <button
            onClick={handleData}
            type="button"
            className="p-2 text-white rounded-lg bg-[black] absolute bottom-[1%] left-[30%] right-[30%] cursor-pointer"
          >
            {txt}
          </button>
            </div>:<Empty />
        }
       <>

       </>
        
      </div>
      <div className="overflow-hidden">
      <h1 className="text-white">Invitation</h1>
      {
        eventNotifications.length>0?  <FixedSizeList
        height={1000}
        width={"100%"}
        itemSize={100}
        itemCount={eventNotifications.length}
        overscanCount={5}
        itemData={eventNotifications}
      >
        {renderRow2}
      </FixedSizeList>:<Empty />
      }
    
      </div>
      </>} </>
  );
}

export default NotificationPageRes;
